import React, { useState } from 'react';
import { Button, Container, Icon, Input } from 'semantic-ui-react';

interface ExecMemberAddProps {
  onAdd: (nominativo: string) => void;
}

export const ExecMemberAdd: React.FC<ExecMemberAddProps> = ({ onAdd }) => {
  const [memberName, setMemberName] = useState('');

  return (
    <Container fluid>
      <Input
        style={{ marginRight: '1em', width: '400px' }}
        value={memberName}
        onChange={(e) => {
          setMemberName(e.target.value);
        }}
        input={{
          onKeyPress: (e: any) => e.which === 13 && e.preventDefault(),
        }}
      />
      <Button
        icon
        type={'button'}
        disabled={memberName.length === 0}
        onClick={() => {
          onAdd(memberName);
          setMemberName('');
        }}
      >
        <Icon name="add circle" />
      </Button>
    </Container>
  );
};
